import React from "react"
import { BigTeaserContainer, ReadMore } from "./style"

const BigTeaser = ({
  title,
  tag,
  excerpt,
  date,
  label,
  img,
  link,
  index,
  className,
}) => {
  return (
    <BigTeaserContainer
      className={className}
      index={index}
      title={title}
      excerpt={excerpt}
      tag={tag}
      date={date}
      img={img}
      child={index}
    >
      <ReadMore to={link}>
        <span>{label}</span>
      </ReadMore>
    </BigTeaserContainer>
  )
}

export default BigTeaser
